import * as React from "react";
import { forwardRef } from "react";
const SvgIconWeb = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 6.5, stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ React.createElement("ellipse", { cx: 8, cy: 8, rx: 2, ry: 6, stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ React.createElement("path", { d: "M1.5 8h13", stroke: "currentColor", strokeWidth: 1.2 }));
const ForwardRef = forwardRef(SvgIconWeb);
export default ForwardRef;
